'use client';

import React from 'react';

import ErrorState from '@/app/(main)/_components/error-state/error-state';
import { getLogger } from '@/logger/get-logger';

interface ErrorBoundaryState {
  hasError: boolean;
}

interface ErrorBoundaryProps {
  metadata?: Record<string, unknown>;
  errorMessage: string;
  fallback?: React.ReactNode;
};

export class ErrorBoundary extends React.Component<React.PropsWithChildren<ErrorBoundaryProps>, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    const logger = getLogger('ErrorBoundary', this.props?.metadata ?? {});
    logger?.error(this.props.errorMessage, { error, info });
  }

  render() {
    if (this.state.hasError) {
      if (this.props?.fallback) {
        return this.props.fallback;
      }

      return (
        <ErrorState onReset={() => window?.location?.reload()} />
      );
    }
    return this.props.children;
  }
}
